import React, { useState } from 'react';
import Template from '../components/Template';
import SincronizacaoManualNota from '../components/SincronizacaoManualNota';
import SuccessModal from '../components/SuccessModal';

const Dashboard = () => {
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [message, setMessage] = useState('');

    // Handlers para sincronização manual
    const handleSincronizacaoSucesso = (mensagem) => {
        setMessage(mensagem);
        setShowSuccessDialog(true);
    };

    const handleSincronizacaoErro = (mensagem) => {
        setMessage(mensagem);
        setShowSuccessDialog(true);
    };

    return (
        <Template>
            <div>
                {/* Área de ações rápidas no topo */}
                <div className="bg-white border-b border-gray-200 px-6 py-4">
                    <div className="flex items-center justify-between">
                        <div>
                            <h1 className="text-lg font-semibold text-gray-900">Ações Rápidas</h1>
                            <p className="text-sm text-gray-600">Ferramentas de uso frequente</p>
                        </div>
                        <SincronizacaoManualNota 
                            onSuccess={handleSincronizacaoSucesso}
                            onError={handleSincronizacaoErro}
                        />
                    </div>
                </div>

                {/* Modal de Sucesso/Erro */}
                {showSuccessDialog && (
                    <SuccessModal
                        isVisible={showSuccessDialog}
                        message={message}
                        onClose={() => setShowSuccessDialog(false)}
                    />
                )}
            </div>
        </Template>
    )
}
export default Dashboard;
